import React, { useState } from "react";

const EditImg = ({ isActive }) => {
  const [isHovered, setIsHovered] = useState(false);

  const fillColor = isActive ? "#EBF2F7" : isHovered ? "#1D4469" : "#969BA9";
  const bgColor = isActive ? "#1D4469" : "white";

  return (
    <span onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)}>
      <svg xmlns="http://www.w3.org/2000/svg" width="33" height="33" viewBox="0 0 33 33" fill="none">
        <rect
          x="0.5"
          y="0.5"
          width="32"
          height="32"
          rx="4.5"
          fill={bgColor}
          stroke={isHovered ? "#1D4469" : "#DFE2E5"}
        />
        <path
          d="M21.3212 16.5C21.0254 16.5 20.7855 16.7399 20.7855 17.0357V22.3929C20.7855 22.6887 20.5457 22.9286 20.2498 22.9286H10.6071C10.3112 22.9286 10.0714 22.6887 10.0714 22.3929V11.6786C10.0714 11.3827 10.3112 11.1428 10.6071 11.1428H17.0356C17.3315 11.1428 17.5713 10.903 17.5713 10.6071C17.5713 10.3112 17.3315 10.0714 17.0356 10.0714H10.6071C9.71953 10.0714 9 10.791 9 11.6786V22.3929C9 23.2805 9.71953 24 10.6071 24H20.2498C21.1374 24 21.857 23.2805 21.857 22.3929V17.0357C21.857 16.7399 21.6171 16.5 21.3212 16.5Z"
          fill={fillColor}
        />
        <path
          d="M23.3995 9.60074C23.0148 9.21603 22.4931 8.99995 21.9491 9.00001C21.4048 8.99844 20.8826 9.2149 20.499 9.60109L13.4426 16.657C13.3841 16.7159 13.3399 16.7876 13.3135 16.8664L12.2421 20.0807C12.1486 20.3614 12.3004 20.6648 12.5811 20.7582C12.6355 20.7764 12.6926 20.7856 12.75 20.7857C12.8075 20.7856 12.8646 20.7764 12.9192 20.7584L16.1335 19.687C16.2124 19.6606 16.2841 19.6162 16.3429 19.5573L23.3993 12.5009C24.2002 11.7001 24.2003 10.4016 23.3995 9.60074ZM22.6418 11.7439L15.6776 18.7082L13.5969 19.403L14.2896 17.325L21.2564 10.3607C21.6394 9.97845 22.2598 9.97908 22.6421 10.3621C22.8247 10.5451 22.9276 10.7928 22.9284 11.0513C22.929 11.3111 22.8259 11.5605 22.6418 11.7439Z"
          fill={fillColor}
        />
      </svg>
    </span>
  );
};

export default EditImg;
